import script from "./kakaoSibalMap.vue?vue&type=script&setup=true&lang=js"
export * from "./kakaoSibalMap.vue?vue&type=script&setup=true&lang=js"

import "./kakaoSibalMap.vue?vue&type=style&index=0&id=d8245eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8245eaa"]])

export default __exports__